import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDAlert,
  FDPaper, FDStack, FDTitleText,
} from '@facet-wealth/design';
import SmartAutoCustomizationGroupList
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Templates/SmartAllocationCustomizationPicker/NewSmartAllocationCustomization/Content/SmartAutoCustomizationGroupsPicker/SmartAutoCustomizationGroups/SmartAutoCustomizationGroupList';
import { GuidedHouseholdReviewDraggableGoal } from './draggableGoal';
import { GuidedHouseholdReviewNonDraggableGoal } from './nonDraggableGoal';

export const GuidedHouseholdReviewGoalPriorityLayout = () => {
  const {
    resource, handleChange,
  } = useMetaLayoutContext();
  return (
    <FDStack direction={'column'} spacing={3}>
      <FDAlert
        description="If goals have equal priority, drag one over another to create a new group"
        status="info"
      />
      <FDPaper padding={2}>
        <FDStack direction={'column'} spacing={1}>
          <FDStack direction={'row'} spacing={1} justifyContent={'center'}>
            <FDTitleText size={'md'} value={'(Most important)'} />
          </FDStack>
          <FDStack direction={'column'} padding={1}>
            {
              resource.attr('stepSet').resources().list().map(stepSet => (
                <SmartAutoCustomizationGroupList
                  key={stepSet.id()}
                  groupResource={stepSet}
                  isOptimisticallyUpdating={false}
                  optimisticUpdateSacGroup={(_, updatedGoalResource) => {
                    resource.attr('stepSet').resources().updateItem(updatedGoalResource);
                    handleChange('stepSet', resource.attr('stepSet'));
                    resource.submit();
                  }}
                  StepComponent={stepSet.isTruthy('canBeRanked') ? GuidedHouseholdReviewDraggableGoal : GuidedHouseholdReviewNonDraggableGoal}
                  showActiveStatus={false}
                  onlyDragContent
                />
              ))
            }
          </FDStack>
          <FDStack direction={'row'} spacing={1} justifyContent={'center'}>
            <FDTitleText size={'md'} value={'(Least important)'} />
          </FDStack>
        </FDStack>
      </FDPaper>
    </FDStack>
  );
};
